(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-remove.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-remove.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  deleteCellPhone
} = svs.myProfile.react.store.pdPreferences.actions;
const trackEventDelete = deleted => {
  const track = {
    category: 'My Profile',
    action: 'mobile delete',
    opt_label: deleted ? 'Yes' : 'No'
  };
  svs.components.analytics.trackEvent(track);
};
const {
  showDeleteErrorDialog,
  confirmDelete,
  onDeleteCellphoneSuccess
} = svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileDialogs;

const MobileRemove = () => {
  const dispatch = ReactRedux.useDispatch();
  const onDeletePhoneHandler = async e => {
    e.preventDefault();
    const isDeleteConfirmed = await confirmDelete();
    svs.myProfile.logger.debug('mobile.jsx: isDeleteConfirmed done', isDeleteConfirmed);
    if (!isDeleteConfirmed) {
      trackEventDelete(false);
      return;
    }
    const deleteResponse = await dispatch(deleteCellPhone());
    if (RTK.isFulfilled(deleteResponse)) {
      trackEventDelete(true);
      onDeleteCellphoneSuccess();
    } else {
      showDeleteErrorDialog();
    }
  };
  return React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: onDeletePhoneHandler,
    size: 300,
    transparent: true,
    type: "submit"
  }, "Ta bort mobilnummer");
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileRemove = MobileRemove;

 })(window);